export enum DatasheetComponentTextStyle {
  bold = 4,      // BOLD_MASK from Java DomConstants
  italic = 2,    // ITALIC_MASK from Java DomConstants
  underline = 16, // ULINE_MASK from Java DomConstants
}